export const COMMENTS = [
  {
    id: 0,
    type: "High Performer",

    gender: "boy",
   text:
      "firstName lastName is an enthusiastic learner who seems to enjoy school. He takes responsibility for his learning and strives to reach his full potential. He has exceeded expectations with the quality of his work. I encourage firstName to continue to put his best foot forward.",
  },
  {
    id: 1,
    type: "High Performer",

    gender: "girl",
   text:
      "firstName lastName is an enthusiastic learner who seems to enjoy school. She takes responsibility for her learning and strives to reach her full potential. She exceeds expectations with the quality of her work. I encourage firstName to continue to put her best foot forward.",
  },
  {
    id: 2,
    type: "High Performer",
    gender: "boy",
   text:
      "firstName lastName is a model student. He exhibits a positive outlook and attitude in the classroom. He tackles classroom assignments, tasks, and group work in an organized manner. He listens attentively to responses of others while also taking an active role in classroom discussion. His enthusiasm for learning has contributed to his outstanding performance in all subject areas. I encourage firstName to keep up the great work.",
  },
  {
    id: 3,
    type: "High Performer",
    gender: "girl",
   text:
      "firstName lastName is a model student. She exhibits a positive outlook and attitude in the classroom. She tackles classroom assignments, tasks, and group work in an organized manner. She listens attentively to responses of others while also taking an active role in classroom discussion. Her enthusiasm for learning has contributed to her outstanding performance in all subject areas. I encourage firstName to keep up the great work.",
  },
  {
    id: 4,
    type: "High Performer",
    gender: "boy",
   text:
      "firstName lastName is able to cooperate and work well with any student in the classroom. He is very hardworking and completes all assignments in a timely manner. He expresses ideas clearly, both verbally and through writing. He has demonstrated that he has an excellent understanding of concepts taught this quarter. I encourage firstName to continue to be a shining star.",
  },
  {
    id: 5,
    type: "High Performer",
    gender: "girl",
   text:
      "firstName lastName is able to cooperate and work well with any student in the classroom. She is very hardworking and completes all assignments in a timely manner. She expresses ideas clearly, both verbally and through writing. She has demonstrated that she has an excellent understanding of concepts taught this quarter. I encourage firstName to continue to be a shining star.",
  },
  {
    id: 6,
    type: "Behavior Problems",
    gender: "boy",
   text:
   "firstName lastName comes to class on time every day with a smile on his face. firstName is pleasant and friendly.  Occasionally, he needs to be reminded to stay on task. He can improve his focus and concentration during instruction. He has the potential to do well when he completes assignments. I am looking forward to seeing firstName progress next quarter." 

  },
  {
    id: 7,
    type: "Behavior Problems",
    gender: "girl",
   text:
   "firstName lastName comes to class on time every day with a smile on her face. firstName is pleasant and friendly.  Occasionally, she needs to be reminded to stay on task. She can improve her focus and concentration during instruction. She has the potential to do well when she completes assignments. I am looking forward to seeing firstName progress next quarter." 

  },
  {
    id: 8,
    type: "Behavior Problems",
    gender: "boy",
   text:
   "firstName lastName is a very positive and upbeat student. He makes friends quickly in the classroom and has excellent attendance. At times he is distracting to his friends and classmates. He can improve by listening carefully during instruction and focusing during independent work. I know that firstName can reach his goals if he continues to work hard."


  },
  {
    id: 9,
    type: "Behavior Problems",
    gender: "girl",
   text:
   "firstName lastName is a very positive and upbeat student. She makes friends quickly in the classroom and has excellent attendance. At times she is distracting to her friends and classmates. She can improve by listening carefully during instruction and focusing during independent work. I know that firstName can reach her goals if she continues to work hard."
  },
  {
    id: 10,
    type: "Behavior Problems",
    gender: "boy",
   text:
   "firstName lastName has great attendance and comes to class on time everyday. He is respectful to teachers and classmates. One area for improvement for firstName is for him to complete assignments on time. He is encouraged to use time wisely to finish tasks in the time required. Also, he is encouraged to ask for help when needed. I am looking forward to seeing firstName progress next quarter."
  },
  {
    id: 11,
    type: "Behavior Problems",
    gender: "girl",
   text:
   "firstName lastName has great attendance and comes to class on time everyday. She is respectful to teachers and classmates. One area for improvement for firstName is for her to complete assignments on time. She is encouraged to use time wisely to finish tasks in the time required. Also, She is encouraged to ask for help when needed. I am looking forward to seeing firstName progress next quarter."
  },
  {
    id: 12,
    type: "Behavior Problems",
    gender: "boy",
   text:
   "firstName lastName shows respect for peers and teachers. He is an enthusiastic learner who enjoys school. It is awesome that he is eager to participate in class but he needs to raise his hand to be fair to all students. Occasionally, firstName  needs to be reminded to stay in his seat. I know that firstName  can reach his goals if he continues to work hard."
  },
  {
    id: 13,
    type: "Behavior Problems",
    gender: "girl",
   text:
   "firstName lastName shows respect for peers and teachers. She is an enthusiastic learner who enjoys school. It is awesome that she is eager to participate in class but she needs to raise her hand to be fair to all students. Occasionally, firstName  needs to be reminded to stay in her seat. I know that firstName  can reach her goals if she continues to work hard."
  },
  {
    id: 14,
    type: "Behavior Problems",
    gender: "boy",
   text:
   "firstName lastName comes to class on time every day. He is hard-working and self-confident. He is learning how to follow the classroom rules and procedures. One area for improvement is for firstname to treat others with respect. I am looking forward to seeing him progress next quarter."
  },
  {
    id: 15,
    type: "Behavior Problems",
    gender: "girl",
   text:
   "firstName lastName comes to class on time every day. She is hard-working and self-confident. She is learning how to follow the classroom rules and procedures. One area for improvement is for firstname to treat others with respect. I am looking forward to seeing her progress next quarter."
  },
  {
    id: 16,
    type: "Average Performer",
    gender: "boy",
   text:
   "firstName lastName exhibits a positive outlook and attitude in the classroom. He is thoughtful and kind in his interactions with others. He is well prepared for class each day. He has demonstrated that he has a good understanding of the concepts and skills taught this quarter. He has made decent progress in all subject areas."
  },
  {
    id: 17,
    type: "Average Performer",
    gender: "girl",
   text:
   "firstName lastName exhibits a positive outlook and attitude in the classroom. She is thoughtful and kind in her interactions with others. She is well prepared for class each day. She has demonstrated that she has a good understanding of the concepts and skills taught this quarter. She has made decent progress in all subject areas."
  },
  {
    id: 18,
    type: "Average Performer",
    gender: "boy",
   text:
   "firstName lastName demonstrates responsibility daily by caring for the materials in our classroom. He is exceptionally organized and takes care of his things. He remains an active learner throughout the school day. Overall, he has done a good job this quarter."
  },
  {
    id: 19,
    type: "Average Performer",
    gender: "girl",
   text:
   "firstName lastName demonstrates responsibility daily by caring for the materials in our classroom. She is exceptionally organized and takes care of her things. She remains an active learner throughout the school day. Overall, She has done a good job this quarter."
  },
  {
    id: 20,
    type: "Average Performer",
    gender: "boy",
   text:
   "firstName lastName sets an example of excellence in behavior and cooperation. He takes his classroom job seriously and demonstrates responsibility when completing it. He checks his work thoroughly before submitting it. He has strengthened his skills in all subject areas this quarter."
  },
  {
    id: 21,
    type: "Average Performer",
    gender: "girl",
   text:
   "firstName lastName sets an example of excellence in behavior and cooperation. She takes her classroom job seriously and demonstrates responsibility when completing it. She checks her work thoroughly before submitting it. She has strengthened her skills in all subject areas this quarter."
  },
  {
    id: 22,
    type: "Below Average Performer",
    gender: "boy",
   text:
   "firstName lastName is well liked by classmates. He is caring and concerned with the feelings of his  peers. Although he is a great friend, he works fast and makes careless mistakes on assignments. He would greatly benefit from slowing down and checking his assignments."
  },
  {
    id: 23,
    type: "Below Average Performer",
    gender: "girl",
   text:
   "firstName lastName is well liked by classmates. She is caring and concerned with the feelings of her peers. Although she is a great friend, she  works fast and makes careless mistakes on assignments. She would greatly benefit from slowing down and checking her assignments."
  },
  {
    id: 24,
    type: "Below Average Performer",
    gender: "boy",
   text:
   "firstName lastName arrives on time to school every day and is always well prepared for class. He has a great sense of humor and loves to make jokes and play. One area  he can improve is managing his time effectively. He is encouraged to make good use of his time by understanding that there is a time to study and a time to play."
  },
  {
    id: 25,
    type: "Below Average Performer",
    gender: "girl",
   text:
   "firstName lastName arrives on time to school every day and is always well prepared for class. She has a great sense of humor and loves to make jokes and play. One area she can improve is managing her time effectively. She is encouraged to make good use of her time by understanding that there is a time to study and a time to play."
  },
  {
    id: 26,
    type: "Below Average Performer",
    gender: "boy",
   text:
   "firstName lastName shows empathy towards his peers. He takes time to think before he speaks. However, he has a hard time working independently and completing assignments which is reflected in his grades. He can benefit from completing assignments on time and listening carefully during instruction."
  },
   {
    id: 27,
    type: "Below Average Performer",
    gender: "girl",
   text:
   "firstName lastName shows empathy towards her peers. She takes time to think before she speaks. She  has a hard time working independently and completing assignments which is reflected in her grades. She can benefit from completing assignments on time and listening carefully during instruction."
  },

];
